import { ChangeDetectorRef, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { DialogService } from '@mtgame/ui';
import { isPlatformBrowser } from '@angular/common';
import {
  ConfigService,
  League, Tournament, TournamentApi, TournamentRound,
  TournamentSeason,
} from '@mtgame/core';
import { HttpClient } from '@angular/common/http';
import { JoinComponent } from '../../../app/join/join.component';
import { LeagueRootService } from '@core/services/league-root.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'mtg-hockey-league-about',
  templateUrl: './hockey-league-about.component.html',
  styleUrls: ['../shared/league-about.scss', './hockey-league-about.component.scss'],
})
export class HockeyLeagueAboutComponent implements OnInit {
  statistic: any;
  league: League;
  seasons: TournamentSeason[];
  tournaments: Tournament[];
  rounds: {[key: number]: TournamentRound[]} = {};
  season: number;
  roundId: number;
  tournamentId: number;
  allStatistic = true;

  constructor(
    private leagueRootService: LeagueRootService,
    private cdr: ChangeDetectorRef,
    private dialogService: DialogService,
    private httpClient: HttpClient,
    private configService: ConfigService,
    private tournamentApi: TournamentApi,
    @Inject(PLATFORM_ID) private platformId: string,
  ) {
  }

  async ngOnInit(): Promise<void> {
    this.league = this.leagueRootService.getLeagueModel();
    this.seasons = this.leagueRootService.getActiveSeasonsModel();

    this.leagueRootService.seasonTournaments$
      .pipe(take(1))
      .subscribe(async tournaments => {
        this.tournaments = tournaments;
        const rounds = await Promise.all(tournaments.map(item => this.tournamentApi.getTournamentRounds(item.id)));
        tournaments.forEach((item, index) => {
          this.rounds[item.id] = rounds[index];
        });
        this.cdr.markForCheck();
      });
    if (isPlatformBrowser(this.platformId)) {
      await this.getSeasonStatistic();
    }
  }

  openJoinForm(): void {
    this.dialogService.open(JoinComponent, {
      isCloseButtonVisible: true
    });
  }

  async getSeasonStatistic(tournamentId?: number, roundId?: number) {
    this.tournamentId = tournamentId;
    this.roundId = roundId;
    let url = `${this.configService.get('apiUrl')}/api/v1/league/${this.league.id}/hockey_live_statistic/`;
    if (this.tournamentId) {
      this.allStatistic = false;
      url = `${url}?tournament_ids=${this.tournamentId}`;
      if (this.roundId) {
        url += `&tournament_round_id=${this.roundId}`;
      }
    } else {
      this.allStatistic = true;
    }

    this.statistic = await this.httpClient
      .get(url)
      .toPromise();

    this.cdr.markForCheck();
  }
}
